import {
  relatedProductsSlider,
  upSellProductsSlider,
  ProductMiniatureGallerySlider,
} from "./sliders";
import { fitProductColorSwatches } from "../woocommerce/product-color-swatches";

export const initAjaxProducts = () => {
  const placeholders = document.querySelectorAll("[data-ajax-products]");
  if (!placeholders.length) return;

  const { ajaxUrl } = window.sebaAjax || {};
  if (!ajaxUrl) return;

  placeholders.forEach((placeholder) => {
    const productId = placeholder.dataset.productId;
    const type = placeholder.dataset.type;

    const body = new URLSearchParams({
      action: "seba_load_products",
      product_id: productId,
      type,
    });

    fetch(ajaxUrl, { method: "POST", body })
      .then((r) => r.text())
      .then((html) => {
        if (!html.trim()) return;

        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        const newEl = tmp.firstElementChild;
        if (!newEl) return;

        placeholder.replaceWith(newEl);

        // Inicjalizacja zewnętrznego slidera (related/upsell carousel)
        if (type === "related") relatedProductsSlider();
        else if (type === "upsell") upSellProductsSlider();

        // Inicjalizacja wewnętrznych sliderów miniaturek zdjęć w kartach produktów
        newEl.querySelectorAll(".splide--product-thumbnail-slider").forEach((el) => {
          ProductMiniatureGallerySlider(el);
        });

        fitProductColorSwatches();
      })
      .catch(() => {});
  });
};
